import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appNoDblClick]'
})
export class appNoDblClickDirective {

  @HostListener('dblclick', ['$event']) onDoubleClick(event: Event) {
    event.preventDefault();
    event.stopPropagation(); 
  }
}
